import { useState, useEffect } from "react";
import { Button, Form } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { InputField } from "../../../../CommonElements";
import useAxios from "../../../../Utils/useAxios";
import createKurir from "../serivces/createKurir";
import updateKurir from "../serivces/updateKurir";

const KurirForm = ({ resetState, toggle, data }) => { 
  console.log(data);  
  const [loading, setLoading] = useState(false);
  const axiosInstance = useAxios();
  
  const { control, handleSubmit, setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      name: data ? data.nama : "",
    },
  });

  useEffect(() => {
    // Set form value if data exists
    if (data) {
      setValue("nama", data.nama || "");
    }
  }, [data, setValue]);

  const onSubmit = async (formData) => {
    setLoading(true);
    
    try {
      if (data?.id) {
        await updateKurir(axiosInstance, data.id, formData);
      } else {
        await createKurir(axiosInstance, formData);
      }
      resetState();
      toggle();
    } catch (error) {
      console.error('Error saving kurir:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        name="nama"
        control={control}
        rules={{ required: "Nama is required" }}  
        render={({ field, fieldState }) => (
          <InputField
            label="Nama"
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Button color="primary" type="submit" disabled={loading}>
        {loading ? "Saving..." : "Save"}
      </Button>
    </Form>
  );
};

export default KurirForm;